import { useCallback } from 'react';
import FJModal from '../FJModal';
import FJRenameModal from './FJRenameModal';
import useLocalStore from '../../../hooks/useLocalStore';
import FJLocalStore from '../../../store/FJLocalStore';
import { FJModalsAction } from '../../../redux/action/FJModalsAction';
import { FJDetailsPageAction } from '../../../redux/action/FJDetailsPageAction';
import { FJStartLandingAction } from '../../../redux/action/FJStartLandingAction';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import FJRequirementsUtil from '../../../util/FJRequirementsUtil';

export default function FJRenameModalContainer() {
    useLocalStore();
    const dispatch = useAppDispatch();
    const { display, initialTitle, context, targetId } = useAppSelector(state => state.modals.renameModalData);
    const projectItems = useAppSelector(state => state.startLanding.projects.items);

    const onCancel = useCallback(() => {
        dispatch(FJModalsAction.hideRenameModalAction());
    }, [dispatch]);

    const handleConfirm = useCallback(
        (next: string) => {
            const title = next.trim();
            if (!title) return;
            if (context === 'project' && targetId) {
                const eventId = projectItems.find(i => i.id === targetId)?.eventId ?? '';
                FJRequirementsUtil.eaLog('recent_file_rename_confirm_click', {
                    eventId,
                    title_content: initialTitle ?? '',
                    new_title_content: title,
                });
                dispatch(FJStartLandingAction.renameProjectAction({ id: targetId, title }));
            } else if (context === 'details-clip' && targetId) {
                dispatch(FJDetailsPageAction.applyRenameClipAction({ id: targetId, title }));
            }
        },
        [dispatch, context, targetId, initialTitle, projectItems],
    );

    return (
        <FJModal visible={display}>
            <FJRenameModal
                titleText={FJLocalStore._('rename')}
                placeholderText={''}
                initialValue={initialTitle}
                visible={display}
                onCancel={onCancel}
                onConfirm={handleConfirm}
                onClose={onCancel}
            />
        </FJModal>
    );
}
